import { ProgressBar } from "@blueprintjs/core";
import { useSelectorWall } from "@package/ui-redux";
import { type SliceWallInitialization } from "@package/ui-wall-engine";

function getLoadingPercent(initalization: SliceWallInitialization): number {
  switch (initalization) {
    case "starting":
      return 0.25;
    case "activating":
      return 0.5;
    case "loading":
      return 0.75;
    case "running":
      return 1;
    default:
      return 0;
  }
}

function getLoadingText(initalization: SliceWallInitialization): string {
  switch (initalization) {
    case "starting":
      return "Initializing...";
    case "activating":
      return "Activating...";
    case "loading":
      return "Loading Content...";
    case "running":
      return "Complete";
    default:
      return "";
  }
}

export function WallLoading() {
  const initialization = useSelectorWall((state) => state.wall.initalization);

  return (
    <div className="flex h-full w-full items-center justify-center text-white">
      <div className="w-1/4">
        <div className="mb-96">
          <ProgressBar
            animate
            intent="primary"
            stripes
            value={getLoadingPercent(initialization)}
          />
        </div>
        <div className="text-5xl text-gray-100">
          {getLoadingText(initialization)}
        </div>
      </div>
    </div>
  );
}
